<template>
  <div class="ArtistConfirmationView text-center">
    <template v-if="isError">
      <div>
        <h1 class="font-family-display font-weight-bold my-24">
          Whoops!
          <br />
          Something went wrong.
        </h1>
        <p>
          Got to the
          <router-link :to="{ name: 'Login' }"> login page </router-link>
        </p>
      </div>
    </template>
    <template v-else>
      <h1 class="font-family-display font-weight-bold mb-8">
        Awesome!
        <br />
        You've confirmed your email! 🎉
      </h1>
      <p class="mb-24">
        Got to the
        <router-link :to="{ name: 'Login' }"> login page </router-link>
      </p>
      <div class="ArtistConfirmationView__inner">
        <img
          class="ArtistConfirmationView__img"
          src="/illustration_medidate.svg"
          alt="Illustration of person in a meditation position"
        />
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useOnboardingStore } from '@/stores/onboardingStore'

const props = defineProps({
  mailConfirmationToken: {
    type: String,
    default: ''
  }
})

const isError = ref(false)

const { confirmArtist } = useOnboardingStore()

onMounted(async () => {
  try {
    await confirmArtist(props.emailConfirmationToken)
  } catch (error) {
    isError.value = true
  }
})
</script>

<style lang="scss" scoped>
.ArtistConfirmationView {
  padding: 0 rem(16);

  &__inner {
    max-width: rem(400);
    margin: 0 auto;
  }

  &__img {
    max-width: 100%;
  }
}
</style>
